// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-switch__menu[data-v-42159102]{list-style-type:none;padding:0;margin:0}.language-switch__item+.language-switch__item[data-v-42159102]{margin-top:1em}.language-switch__item button[data-v-42159102]{width:100%}", ""]);
// Exports
module.exports = exports;
